import styled, { css } from "styled-components";

export const StyledRatingWrapper = styled.div`
    margin-top: -10px;
`;

export const StyledIconButtonWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;

export const StyledTypographyWrapper = styled.div`
    ${({ showRating }) => showRating && css`
        display: inline-flex;
        align-items: center;
    `};
`;

export const StyledUser = styled.div`
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    ${StyledTypographyWrapper} {
        flex: 1;
        margin-left: 15px;
    };
    ${({ interactive }) => interactive && css`
        flex-direction: column;
        ${StyledTypographyWrapper} {
            margin-top: 15px;
            margin-left: 0;
        };
    `};
`;
